import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotifyAlertType } from '../../../core/constants/constants';

@Component({
  selector: 'notify-alert',
  templateUrl: './notify-alert.component.html',
  styleUrls: ['./notify-alert.component.scss']
})

export class NotifyAlertComponent {
  @Input() errorMessage: string;
  @Input() externalStyles: any = {};
  @Input() id: string = 'theNotifyAlert';
  @Input() type: NotifyAlertType = NotifyAlertType.DANGER;
  @Input() actionString: string; // this is for a separate (not embeded) actionable link, do not provide if one is not required
  @Output() actionClicked = new EventEmitter(); // if the action link is clicked, not required if there is no action
  
  showAlert: boolean = true;

  constructor(public translateSvc: TranslateService) { }

  closeAlert()
  {
    this.showAlert = false;
  }

  actionLinkClicked()
  {
    this.actionClicked.emit();
  }
}